import { defineStore } from 'pinia'
import { markRaw } from 'vue'
import { useSetIndexStore } from './setindex.store'

export const useThaiStockStore = defineStore('thaistock', {
  state: () => ({
    // dataframe (non-reactive)
    frame: markRaw([] as any[]),

    // วันที่ที่เคย fetch แล้ว
    fetchedDates: markRaw([] as string[]),

    loading: false,
    error: null as string | null,
  }),

  getters: {
    // 🔗 calendar จาก setindex.store (read-only dependency)
    calendar(): readonly string[] {
      return useSetIndexStore().calendar
    },
  },

  actions: {
    /* ===============================
       Load EOD window (SMART)
    =============================== */
    async loadEodWindow(
      centerDate: string,
      before = 5,
      after = 5
    ) {
      const setIndexStore = useSetIndexStore()

      // ensure calendar ready
      if (!setIndexStore.calendarReady) {
        await setIndexStore.fetchCalendar()
      }

      const calendar = setIndexStore.calendar

      // resolve window จาก calendar
      const idx = calendar.indexOf(centerDate)
      if (idx === -1) return

      const start = Math.max(0, idx - before)
      const end = Math.min(calendar.length - 1, idx + after)

      const windowDates = calendar.slice(start, end + 1)

      // เช็คว่าวันไหนยังไม่เคย fetch
      const missingDates = windowDates.filter(
        d => !this.fetchedDates.includes(d)
      )

      if (!missingDates.length) return

      this.loading = true

      try {
        const res = await fetch(
          'https://stock-api.nextbar.trade/thaistock/eod/window',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              center_date: centerDate,
              before,
              after,
              fields: [
                'open',
                'high',
                'low',
                'close',
                'prior',
                'total_value',
                'tr_value',
              ],
            }),
          }
        ).then(r => r.json())

        // append-only
        for (const date in res.data) {
          if (this.fetchedDates.includes(date)) continue

          const rows = res.data[date]

          for (const r of rows) {
            let gain: number | null = null

            if (
              typeof r.close === 'number' &&
              typeof r.prior === 'number' &&
              r.prior > 0
            ) {
              gain = ((r.close - r.prior) / r.prior) * 100
            }

            this.frame.push({
              date,
              ...r,
              gain,
            })
          }

          this.fetchedDates.push(date)
        }
      } catch (e: any) {
        this.error = e.message ?? String(e)
      } finally {
        this.loading = false
      }
    },

    /* ===============================
       Utils
    =============================== */

    clearFrame() {
      this.frame.length = 0
      this.fetchedDates.length = 0
    },

    getFrame() {
      return this.frame
    },

    hasDate(date: string): boolean {
      return this.fetchedDates.includes(date)
    },
  },
})
